import { render, staticRenderFns } from "./edgar.vue?vue&type=template&id=4ea30be8&scoped=true"
var script = {}
import style0 from "./edgar.vue?vue&type=style&index=0&id=4ea30be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea30be8",
  null
  
)

export default component.exports